/**Dependencies */
import React, { useState } from "react";

/**Components */

import { SectionAdvise } from "../components/SectionAdvise";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CardCarrousel } from "../components/CardCarrousel";
import Button from "react-bootstrap/Button";
import Slider from "react-slick";

/**Images */
import atardecer from "../images/atractions/Atardecer.png";
import notreDame from "../images/atractions/Notre-Dame.png";
import versailles from "../images/atractions/Versailles.png";
import imgTest from "../images/img-riu.png";
import imgStar from "../images/icons/star-flamingo.png";
import imgTransportation from "../images/icons/icon-transportation.png";
import imgFood from "../images/icons/icon-food.png";

export const BusquedaActividades = () => {
  const [destinies] = useState([
    {
      hotel: "Recorrido Notre Dame",
      location: "Francia, París",
      price: "$000,000",
      days: "10",
      img: notreDame,
    },
    {
      hotel: "Atardecer en Basílica del Sacré",
      location: "Cancún, México",
      price: "$000,000",
      days: "10",
      img: atardecer,
    },
    {
      hotel: "Jardines de Vesailles",
      location: "Francia, París",
      price: "$000,000",
      days: "10",
      img: versailles,
    },
  ]);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <div className="cards-hotels container py-5">
        <Row>
          <Col lg={12}>
            <Card className="shadow-box">
              <Row>
                <Col lg={3} md={4} sm={12}>
                  <img src={imgTest} alt="" style={{ width: "100%" }} />
                </Col>
                <Col lg={5} md={4} sm={12} style={{ paddingLeft: "35px" }}>
                  <div className="star-category py-3">
                    <img src={imgStar} alt="" width={30} />
                    <img src={imgStar} alt="" width={30} />
                    <img src={imgStar} alt="" width={30} />
                    <img src={imgStar} alt="" width={30} />
                    <img src={imgStar} alt="" width={30} />
                    <span
                      className="text-secondary mt-1"
                      style={{ fontSize: "15px" }}
                    >
                      (5.0)
                    </span>
                  </div>

                  <div className="name-hotel">
                    <h4
                      className="text-purple"
                      style={{ fontSize: "30px", fontWeight: 600 }}
                    >
                      Recorrido Torre Eiffel
                    </h4>
                    <p className="text-muted">Francia, París</p>
                  </div>
                  <div className="amenities">
                    <span>
                      <img src={imgFood} alt="" width={35} />
                    </span>
                    <span>
                      <img
                        src={imgTransportation}
                        alt=""
                        width={35}
                        style={{ marginLeft: "15px" }}
                      />
                    </span>
                    <div
                      className="text-amenities pt-4"
                      style={{ lineHeight: "5px" }}
                    >
                      <p className="text-purple">Inglés Español</p>
                      <p className="text-purple">
                        +5 Horas{" "}
                        <span
                          className="text-secondary"
                          style={{ marginLeft: "25px" }}
                        >
                          Urbano
                        </span>
                      </p>
                    </div>
                  </div>
                </Col>
                <Col
                  lg={4}
                  md={4}
                  sm={12}
                  className="d-flex flex-column"
                  style={{ padding: "18px" }}
                >
                  <div className="py-4">
                    <p>Precio por persona</p>
                    <h5
                      className="text-rose"
                      style={{ fontSize: "25px", fontWeight: 600 }}
                    >
                      USD $0,000.00
                    </h5>
                  </div>
                  <div className="mt-auto">
                    <Link to={"/ficha-tours"}>
                      <Button className="btn-purple">Ver Detalles</Button>
                    </Link>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="section-cards-hotel container py-5">
        <h1 className="text-purple text-center pb-5">
          Mira estas <strong className="text-rose">actividades</strong> en el
          mismo destino
        </h1>
        <Row>
          <Slider {...settings}>
            {destinies.map((dataHotel, index) => {
              return (
                <Col
                  lg={4}
                  md={4}
                  sm={12}
                  key={index + 1}
                  className="d-flex justify-content-center pt-4"
                >
                  <CardCarrousel dataInfo={dataHotel} />
                </Col>
              );
            })}
          </Slider>
        </Row>
      </div>
      <div className="section-about-reservation container py-5">
        <SectionAdvise />
      </div>
    </div>
  );
};
